/**
 * UpsellScreen — shown to teachers without `has_math_engine_access`.
 * Currently informational only (no payment wiring yet).
 */
import React from "react";
import { Calculator, CheckCircle2, Lock } from "lucide-react";

const UpsellScreen = () => (
  <div
    className="ae-card p-8 md:p-12 max-w-3xl mx-auto"
    data-testid="math-engine-upsell"
  >
    <div className="flex items-center gap-3 mb-4">
      <span className="h-12 w-12 rounded-xl bg-[#96ded1]/30 grid place-items-center text-[#1c2d3d]">
        <Calculator className="h-6 w-6" />
      </span>
      <div>
        <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#4a6984]/70">
          Premium add-on · coming soon
        </p>
        <h2 className="font-black text-2xl text-[#1c2d3d] tracking-tight">
          The Math Engine
        </h2>
      </div>
    </div>
    <p className="text-[#4a6984]/90 leading-relaxed mb-6 max-w-2xl">
      A dedicated Math instructional workflow that builds an entire unit
      with you — board-aligned scope, diagnostic-informed lessons, and
      adaptive next-steps based on what your class actually learned.
    </p>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
      {[
        ["SCDSB scope and sequence", "Pacing built from your board's unit plans for Grades 4-8."],
        ["Diagnostic-led lessons", "5-question pre-checks that tell you what to teach next."],
        ["Adaptive Lesson 2", "Mastered / Developing / Re-teach — three paths from one exit ticket."],
        ["Pacing tracker", "A gentle nudge every 3 lessons if the unit drifts off plan."],
      ].map(([title, body]) => (
        <div
          key={title}
          className="rounded-xl border border-[#4a6984]/15 bg-white/60 p-4"
        >
          <div className="flex items-start gap-2">
            <CheckCircle2 className="h-4 w-4 text-[#96ded1] mt-0.5 shrink-0" />
            <div>
              <p className="font-bold text-sm text-[#1c2d3d]">{title}</p>
              <p className="text-xs text-[#4a6984]/80 mt-0.5 leading-snug">{body}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
    <div className="rounded-xl border-2 border-dashed border-[#4a6984]/20 bg-[#f4f5f7]/50 p-5 text-center">
      <Lock className="h-5 w-5 text-[#4a6984]/60 mx-auto mb-2" />
      <p className="text-sm font-semibold text-[#4a6984]">
        Math Engine access is currently invite-only while we finish the workflow.
      </p>
      <p className="text-xs text-[#4a6984]/70 mt-1">
        Reach out if you'd like early access. Standard subject lessons stay
        free in the regular generator.
      </p>
    </div>
  </div>
);

export default UpsellScreen;
